import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/l.png'
import _imports_1 from '@/assets/top-logo.png'
import _imports_2 from '@/assets/user-bg.png'


const _withScopeId = n => (_pushScopeId("data-v-6af78485"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "navbar",
  style: {"min-width":"1236px"}
}
const _hoisted_2 = { class: "bar-header bj-flex-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "left-img",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right-img",
  src: _imports_1
}, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  class: "bj-flex-center header-icon",
  style: {"cursor":"pointer"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-title bj-flex-start" }, [
  /*#__PURE__*/_createElementVNode("div", null, "本家饭团管理系统"),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 8px","color":"#cacbcc","font-weight":"500"} }, " | "),
  /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"16px","font-weight":"500"} }, "商家后台")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bj-flexitem-1" }, null, -1))
const _hoisted_9 = { class: "user-add bj-flex-center" }
const _hoisted_10 = { class: "user-info bj-flex-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "user-img",
  src: _imports_2
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_identity_pop = _resolveComponent("identity-pop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["header-login bj-flex-start", { 'header-lg': _ctx.menuShow }])
      }, _hoisted_5, 2),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.menuShow)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: "iconfont icon-close-show",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchTouch(false)))
            }))
          : (_openBlock(), _createElementBlock("i", {
              key: 1,
              class: "iconfont icon-open-show",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchTouch(true)))
            }))
      ]),
      _hoisted_7,
      _hoisted_8,
      _createElementVNode("div", {
        class: "merchant-name bj-flex-center",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cutTouch && _ctx.cutTouch(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.userInfo.merchantName || "") + " ", 1),
        _createVNode(_component_el_icon, {
          class: "el-icon--right",
          size: "14px",
          color: "#000"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_arrow_down)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_dropdown, { onCommand: _ctx.handleDropdown }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, { command: "modifyPwd" }, {
                  default: _withCtx(() => [
                    _createTextVNode("修改密码")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  divided: "",
                  command: "logout"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("退出登录")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_10, [
              (_ctx.userInfo.avatarUrl && _ctx.userInfo.avatarUrl != 'none')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "user-img",
                    src: _ctx.userInfo.avatarUrl
                  }, null, 8, _hoisted_11))
                : (_openBlock(), _createElementBlock("img", _hoisted_12)),
              _createTextVNode(" " + _toDisplayString(_ctx.userInfo.nickName ? _ctx.userInfo.nickName : _ctx.userInfo.realName) + " ", 1),
              _createVNode(_component_el_icon, {
                class: "el-icon--right",
                size: "14px",
                color: "#000"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_arrow_down)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onCommand"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "修改密码",
      modelValue: _ctx.passwordShow,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.passwordShow) = $event)),
      width: "400px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "ruleFormRef",
          style: {"width":"350px"},
          model: _ctx.passwordInfo,
          rules: _ctx.rules,
          "label-position": "right",
          "label-width": "80px",
          "z-index": 99
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "新密码",
              prop: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.passwordInfo.password,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.passwordInfo.password) = $event)),
                  type: "password",
                  placeholder: "请输入新密码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "密码确认",
              prop: "repassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.passwordInfo.repassword,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.passwordInfo.repassword) = $event)),
                  type: "password",
                  placeholder: "请再次输入新密码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { style: {"margin-top":"20px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.passwordShow = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("取 消")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitModifyPwd(_ctx.ruleFormRef)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("提 交")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_identity_pop, {
      ref: "identityPop",
      userIndentity: _ctx.userIndentity,
      userInfo: _ctx.userInfo,
      logoutLogin: false,
      onUserAdd: _ctx.userAdd
    }, null, 8, ["userIndentity", "userInfo", "onUserAdd"])
  ]))
}